import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

const getAll = async (props) => {
  return await axios.get(
    `${API_URL}/groups?limit=${props.countItems}&page=${props.currentPage}&sortField=${props.sortField}&sortType=${props.sortType}`,
    { headers: authHeader() }
  );
};

const getById = async (id) => {
  return await axios.get(`${API_URL}/groups/${id}`, { headers: authHeader() });
};

const create = async (payload) => {
  const response = await axios.post(
    `${API_URL}/groups`,
    { ...payload },
    { headers: authHeader() }
  );
  if (response.data.success) {
    return response.data;
  } else {
    throw new Error(response.data.message);
  }
};

const edit = async (payload) => {
  const response = await axios.put(
    `${API_URL}/groups/${payload.id}`,
    { ...payload },
    { headers: authHeader() }
  );
  if (response.data.success) {
    return response.data;
  } else {
    throw new Error(response.data.message);
  }
};

const del = async (id) => {
  const response = await axios.patch(
    `${API_URL}/groups/${id}/toggle-active`,
    {},
    { headers: authHeader() }
  );
  if (response.data.success) {
    return response.data;
  } else {
    throw new Error(response.data.message);
  }
};

const getUsersFromGroup = async (props) => {
  return await axios.get(
    `${API_URL}/groups/${props.id}/users?limit=${props.countItems}&page=${props.currentPage}&sortField=${props.sortField}&sortType=${props.sortType}`,
    { headers: authHeader() }
  );
};

const addUserToGroup = async (payload) => {
  return await axios.post(
    `${API_URL}/groups/${payload.group_id}/users/${payload.user_id}`,
    {},
    { headers: authHeader() }
  );
};

const removeUserFromGroup = async (payload) => {
  return await axios.delete(
    `${API_URL}/groups/${payload.id}/users/${payload.userId}`,
    { headers: authHeader() }
  );
};

const getOptions = async (id) => {
  const params = {
    id,
    currentPage: 0,
    countItems: 999,
    sortField: "first_name",
    sortType: "ASC",
  };

  try {
    const response = await getUsersFromGroup(params);
    if (response.data.success) {
      return response.data.data.map((u) => ({
        value: u.id,
        text: `${u.first_name} ${u.last_name}`,
      }));
    }
  } catch (error) {
    return [];
  }
};

export default {
  addUserToGroup,
  create,
  del,
  edit,
  getAll,
  getById,
  getOptions,
  getUsersFromGroup,
  removeUserFromGroup,
};
